module.exports = __webpack_public_path__ + "static/media/ic-metric.cba99a48.svg";